/**
 * object utils
 *
 * @author Shigq
 * @date 2021/11/9 14:17
 */
var _ = require('lodash')
var queryString = require('querystring')

/**
 * Object - clone
 *
 * @param sources
 * @returns {*}
 */
function clone(sources) {
	return _.cloneDeep(sources)
}

/**
 * Object - isEmpty
 *
 * @param sources
 * @returns {*}
 */
function isEmpty(sources) {
	var flag = false

	if (_.isObject(sources) || _.isArray(sources)) {
		flag = _.isEmpty(sources)
	} else {
		flag = sources === '' || sources === undefined || sources === null
	}

	return flag
}

/**
 * debounce
 * @param {*} func
 * @param {*} wait
 * @param {*} options
 * @returns {*}
 */
function debounce(func, wait, options) {
	var DEFAULT = {
		WAIT: 1 * 1000,
		OPTIONS: {'leading': true},
	}
	wait = _.isNumber(wait) ? wait : DEFAULT.WAIT
	options = _.isPlainObject(options) ? options : DEFAULT.OPTIONS

	return _.debounce(function () {
		func()
	}, wait, options)
}

/**
 * throttle
 *
 * @param func
 * @param wait
 * @param options
 * @returns {*}
 */
function throttle(func, wait, options) {
	var DEFAULT = {
		WAIT: 1 * 1000,
		OPTIONS: {'trailing': false},
	}

	wait = _.isNumber(wait) ? wait : DEFAULT.WAIT
	options = _.isPlainObject(options) ? options : DEFAULT.OPTIONS

	return _.throttle(function () {
		func()
	}, wait, options)
}

/**
 * upper first case
 *
 * @param str
 * @returns {*}
 */
function toUpperFirstCase(str) {
	return _.upperFirst(str)
}

/**
 * axios - params serializer
 *
 * @description get
 * @param param
 * @returns {string}
 */
function paramsSerializer(param) {
	var formatData = {};

	for(let i in param){
		if( param[i] !== '' && param[i] !== undefined && param[i] !== null){
			formatData[i] = param[i];
		}
	}

	return queryString.stringify(formatData)
}

/**
 * axios -data serializer
 *
 * @description put, post, patch
 * @param data
 * @returns {{}}
 */
function dataSerializer(data) {
	var formatData = {}

	for(let i in data){
		if(!isEmpty(data[i])){
			formatData[i] = data[i];
		}
	}

	return formatData
}

/**
 * 中划线转驼峰，用于格式化多单词的文件名
 */
function toHump(name) {
	return name.replace(/-(\w)/g, (all, letter) => letter.toUpperCase());
}

/**
 * 通过URL中参数名称获取参数值
 *
 * @param paramName
 * @param url
 * @returns {string|null}
 */
function getParamValue(paramName, url) {
	return decodeURIComponent((new RegExp('[?|&]' + paramName + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [undefined, ""])[1].replace(/\+/g, '%20')) || null
}

/**
 * 从字符串获取数字
 *
 * @param str
 * @returns {*|void|string}
 */
function getDigitalFromStr(str) {
	return str.replace(/[^0-9]/ig, '')
}


module.exports = {
	clone,
	isEmpty,
	debounce,
	throttle,
	toUpperFirstCase,
	paramsSerializer,
	dataSerializer,
	toHump,
	getParamValue,
	getDigitalFromStr
}
